
<div class="ui tab segment" data-tab="photo">
  <div class="ui top secondary menu">
    <a class="item" data-tab="photo/shop">店内</a>
    <a class="item" data-tab="photo/library">フォトライブラリー</a>
  </div>

  <div class="ui inner tab" data-tab="photo/shop">
    <table class="ui celled table">
      <tbody>
        <tr v-for="(form, i) in shopImageForms" :key="i">
          <td>
            <form class="ui form" :class="{'warning': form.hasErrors()}">
              <div class="fields">
                <div class="required five wide field">
                  <label>画像</label>
                  <s3 v-model="form.model.image"></s3>
                  <validation-message :form="form" :field="'image'"></validation-message>
                </div>
                <div class="three wide field">
                  <label>サイト選択</label>
                  <div class="ui checkbox" style="display: block; margin-bottom: 5px;">
                    <input v-model="form.model.is_banquet" type="checkbox" value="true">
                    <label>宴会</label>
                  </div>
                  <div class="ui checkbox" style="display: block; margin-bottom: 5px;">
                    <input v-model="form.model.is_meeting" type="checkbox" value="true">
                    <label>会議室</label>
                  </div>
                  <div class="ui checkbox" style="display: block;">
                    <input v-model="form.model.is_lodge_meeting" type="checkbox" value="true">
                    <label>宿泊会議</label>
                  </div>
                </div>
                <div class="eight wide field">
                  <label>説明書き</label>
                  <div style="margin-bottom: 5px;">
                    <input type="text" v-model="form.model.banquet_description" placeholder="説明書き(宴会)">
                    <validation-message :form="form" :field="'banquet_description'"></validation-message>
                  </div>
                  <div style="margin-bottom: 5px;">
                    <input type="text" v-model="form.model.meeting_description" placeholder="説明書き(会議室)">
                    <validation-message :form="form" :field="'meeting_description'"></validation-message>
                  </div>
                  <div>
                    <input type="text" v-model="form.model.lodge_meeting_description" placeholder="説明書き(宿泊会議)">
                    <validation-message :form="form" :field="'lodge_meeting_description'"></validation-message>
                  </div>
                </div>
              </div>
            </form>
          </td>
          <td class="actions">
            <button type="button" class="ui tiny positive button" @click="saveShopImage(form)">保存</button>
            <button type="button" class="ui tiny red button" @click="deleteShopImage(form, i)">削除</button>
          </td>
        </tr>
      </tbody>
      <tfoot class="full-width">
        <th colspan="2">
          <div class="ui center aligned">
            <i class="clickable plus green large icon" @click="newShopImage()"></i>
          </div>
        </th>
      </tfoot>
    </table>
  </div>

  <div class="ui inner tab" data-tab="photo/library">
    <div v-if="!reorderMode">
      <button class="ui mini default button" @click="reorderMode = true">並び順を変更する</button>
    </div>
    <div v-else>
      <button class="ui mini positive button" @click="reorderLibraryImage">並び順を保存する</button>
      <a class="clickable" @click="reload">キャンセル</a>
    </div>
    <table class="ui celled table">
      <tbody>
        <tr v-for="(form, i) in libraryImageForms" :key="i">
          <td v-if="reorderMode" style="width: 30px">
            <i @click="moveUp(libraryImageForms, i)" class="clickable arrow up icon"></i>
            <i @click="moveDown(libraryImageForms, i)" class="clickable arrow down icon"></i>
          </td>
          <td>
            <form class="ui form" :class="{'warning': form.hasErrors()}">
              <div class="fields">
                <div class="required six wide field">
                  <label>画像</label>
                  <s3 v-model="form.model.image"></s3>
                  <validation-message :form="form" :field="'image'"></validation-message>
                </div>
                <div class="three wide field">
                  <label>サイト選択</label>
                  <div class="ui checkbox" style="display: block; margin-bottom: 5px;">
                    <input v-model="form.model.is_banquet" type="checkbox" value="true">
                    <label>宴会</label>
                  </div>
                  <div class="ui checkbox" style="display: block; margin-bottom: 5px;">
                    <input v-model="form.model.is_meeting" type="checkbox" value="true">
                    <label>会議室</label>
                  </div>
                  <div class="ui checkbox" style="display: block;">
                    <input v-model="form.model.is_lodge_meeting" type="checkbox" value="true">
                    <label>宿泊会議</label>
                  </div>
                </div>
                <div class="seven wide field">
                  <label>タグ</label>
                  <div v-for="tag in tags" :key="tag.value" class="ui checkbox">
                    <input v-model="form.model.tags" type="checkbox" :value="tag.value">
                    <label>{{ tag.label }}</label>
                  </div>
                </div>
              </div>
            </form>
          </td>
          <td class="actions">
            <button type="button" class="ui tiny positive button" @click="saveLibraryImage(form)">保存</button>
            <button type="button" class="ui tiny red button" @click="deleteLibraryImage(form, i)">削除</button>
          </td>
        </tr>
      </tbody>
      <tfoot class="full-width">
        <th colspan="2">
          <div class="ui center aligned">
            <i class="clickable plus green large icon" @click="newLibraryImage()"></i>
          </div>
        </th>
      </tfoot>
    </table>
  </div>
</div>
